export default "__VITE_ASSET__BuBygiR0__"